import actions from 'modules/tool/destroy/toolDestroyActions';
import destroyReducers from 'modules/shared/destroy/destroyReducers';

export default destroyReducers(actions);
